import { NgModule } from '@angular/core';
import { ConfirmButtonDirective } from './confirm-button.directive';

@NgModule({
	declarations: [],
	imports: [ConfirmButtonDirective],
	exports: [ConfirmButtonDirective],
})
export class ConfirmButtonModule {}
